import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function PromisesSection() {
  const promises = ['Menos "mensajes impulsivos" (o al menos, más fricción antes de enviarlos)', 'Menos recaídas por redes', 'Un plan claro para cuando reaparece', 'Un mínimo de sueño/apetito/estructura', 'Una sensación nueva: me sostengo'];
  return <section className="bg-[#141210]" style={{
    paddingTop: 'var(--space-section)',
    paddingBottom: 'var(--space-section)',
    paddingLeft: 'var(--pad-x)',
    paddingRight: 'var(--pad-x)'
  }} data-id="element-142">
      <div className="max-w-2xl mx-auto" data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-144">
          <h2 className="fluid-3xl font-bold text-white mb-10 font-serif" data-id="element-145">
            Qué consigues en 7 días <br data-id="element-146" />
            <span className="text-[#9A948C] font-sans font-normal block mt-2 fluid-xl" data-id="element-147">
              (promesas seguras)
            </span>
          </h2>

          <ul className="space-y-6 mb-12" data-id="element-148">
            {promises.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="flex items-start gap-4" data-id="element-149">
                <div className="mt-1 w-6 h-6 rounded-full bg-[#A52422]/20 flex items-center justify-center shrink-0" data-id="element-150">
                  <Check className="w-3.5 h-3.5 text-[#A52422]" data-id="element-151" />
                </div>
                <span className="text-[#F5F0EB]/90 fluid-lg" data-id="element-152">{item}</span>
              </motion.li>)}
          </ul>

          <div className="border-l-4 border-[#A52422] pl-6 py-2" data-id="element-153">
            <p className="italic text-[#9A948C] mb-2 fluid-lg" data-id="element-154">
              No te prometo que vuelves a estar perfecta.
            </p>
            <p className="font-serif text-white font-medium fluid-xl" data-id="element-155">
              Te prometo que dejas de empeorar tu herida cada día.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}